(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.biosxTapPreview) {
  window.biosxTapPreview = true;

  let activePreviewCard = null;
  let touchFrame = null;
  let touchX = 0;
  let touchY = 0;

  const revealBiosxSecondary = card => {
    if (!card || card === activePreviewCard || !card.querySelector('.product-card__image--secondary')) return;

    if (activePreviewCard) {
      activePreviewCard.classList.remove('biosx-preview');
    }

    card.classList.add('biosx-preview');
    activePreviewCard = card;
  };

  document.addEventListener('touchmove', event => {
    const touch = event.touches && event.touches[0];
    if (!touch) return;

    touchX = touch.clientX;
    touchY = touch.clientY;

    if (touchFrame) return;

    touchFrame = requestAnimationFrame(() => {
      touchFrame = null;

      const element = document.elementFromPoint(touchX, touchY);
      const card = element
        ?.closest('.product-card__figure')
        ?.closest('product-card[data-biosx-tap-preview]');

      revealBiosxSecondary(card);
    });
  }, { passive: true });

  document.addEventListener('click', event => {
    if (!matchMedia('(hover: none) and (pointer: coarse)').matches || event.detail === 0) return;

    const link = event.target.closest('.product-card__figure > a');
    const card = link?.closest('product-card[data-biosx-tap-preview]');

    if (!card || !link.querySelector('.product-card__image--secondary')) return;
    if (card === activePreviewCard || card.classList.contains('biosx-preview')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    revealBiosxSecondary(card);
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
